import React, { Component } from 'react'
import api from "../../config/api";
import { connect } from 'react-redux'
import {
    debitsSelectedComp,
    debitsSelectedIDsComp,
    openSnackComp,
    debitsComp
} from "../../actions";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Box, TablePagination } from '@material-ui/core';
import Footer from '../../components/Footer';
import MenuDebitsManager from '../../components/MenuDebitsManager'
import { CardDebit } from '../../components/CardDebit';
import LoadingDefault from '../../components/LoadingDefault';
import Snackbar from '../../components/Snackbar';
import ContentNotLoaded from '../../components/ContentNotLoaded';
import ButtonTypeName from '../../components/ButtonTypeName';
import { arrayRemoveItem } from '../../helper/arrayRemoveItem';
import { errorDefault } from '../../helper/errorDefault';
import { convertDebitsData } from '../../helper/convertDebitsData';
import Messages from '../../helper/resources/Messages';
import TablePaginationActions from '../../components/TablePaginationActions/TablePaginationActions'

const styles = () => ({
    container: {
        padding: '0px 30px 20px 30px',
        marginTop: '130px'
    },
    menuGroup: {
        display: 'flex',
        width: '100%',
        marginTop: '10px',
        marginBottom: '30px',
        padding: '20px 0px 0px 0px',
    },
    menuIcon: {
        width: 30,
        marginRight: 7
    },
    linkGroup: {
        textDecoration: 'none',
    },
    button: {
        color: 'rgb(24, 116, 185)',
        fontSize: 17,
        background: 'none',
        border: 'none',
        boxShadow: 'none',
    },
    loadingDiv: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
    },
    cardContainer: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: 40,
    },
    inputsItem: {
        display: 'flex'

    },
    pagination: {
        //width: '55%',
        border: 'none',
        margin: '0 auto'
    },
})

let sizePage = window.innerWidth
export class HiddenDebts extends Component {
    constructor(props) {
        super(props);
        this.getDebits = this.getDebits.bind(this);

        this.state = {
            debits: [],
            debitsSelected: [],
            isHovering: true,
            isInSelectionMode: false,
            loadingDebits: false,
            errorMessage: '',
            errorLoadDebits: false,
            isNewPageInstance: true,
            lastSearchParams: '',
            rowsPerPage: 36,
            page: 0,
        }
    }

    componentDidMount() {
        this.props.openSnackComp(false)
        this.props.debitsComp([])
        this.props.debitsSelectedComp([])
        this.props.debitsSelectedIDsComp([])
        this.getDebits()

    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.debitsSelected?.length !== this.state.debitsSelected?.length) {
            this.setState({
                isInSelectionMode: this.state.debitsSelected?.length > 0
            })
        }

        return null;
    }

    async getDebits(filterParams) {
        this.setState({
            loadingDebits: true,
            errorMessage: '',
            errorLoadDebits: false,
            snackBarMessage: '',
            isNewPageInstance: false,
            debitsSelected: [],
        }, () => {
            this.props.openSnackComp(false)
            this.props.debitsComp([])
            this.props.debitsSelectedComp([])
            this.props.debitsSelectedIDsComp([])
        })

        try {
            let firstLoad = filterParams === undefined || filterParams === null || filterParams === '';
            let params

            if (firstLoad) {
                params = {
                    tipo: '',
                    cpfCnpj: '',
                    obterOcultados: true,
                }
            } else {
                params = {
                    tipo: filterParams.tipoDocumentoContribuinte,
                    cpfCnpj: filterParams.numeroContribuinte,
                    obterOcultados: true,
                    vincendo: filterParams.vincendo,
                    vencido: filterParams.vencido,
                    exigibilidadeSuspensa: filterParams.exigibilidadeSuspensa,
                    codigoTributo: filterParams.codigoTributo,
                    valorMinimo: filterParams.valorMinimo,
                    valorMaximo: filterParams.valorMaximo,
                    dataVencimentoMinima: filterParams.dataInicio,
                    dataVencimentoMaxima: filterParams.dataFim,
                }
            }

            const debitsGroup = await api.get("Gestao/debitos-ocultados", { params })

            let debitsList = []
            if (debitsGroup.data !== null && debitsGroup.data !== undefined) {
                if (debitsGroup.data.length > 0) {
                    //04/09
                    //O banco está vindo com IdDebitos duplicados. Este código remove os duplicados.
                    //Após este problema ser resolvido (back), apagar isso. De nada!
                    const map = new Map();
                    for (const item of debitsGroup.data) {
                        if (!map.has(item.IdDebito)) {
                            map.set(item.IdDebito, true);
                            debitsList.push(item)
                        }
                    }
                }

                this.setState({
                    debits: debitsList
                })

                debitsList.forEach(item => {
                    convertDebitsData(item)

                    if (this.state.checkAllExpiredDueDate && item.DebitoAtrasado) {
                        this.handleGetCardSelected(item.IdDebito, true)
                        item.CheckedDebt = true
                    }

                    if (this.state.checkAllNearDueDateDebts && item.DebitoVincendo) {
                        this.handleGetCardSelected(item.IdDebito, true)
                        item.CheckedDebt = true
                    }
                })

                this.setState({
                    debits: debitsList,
                    loadingDebits: false,
                    errorLoadDebits: false,
                }, () => {
                    this.props.debitsComp(debitsList)
                })
            }
        } catch (error) {
            let errorMessage = errorDefault(error)

            this.setState({
                errorMessage: errorMessage,
                errorLoadDebits: true,
                loadingDebits: false,
            });
        }
    }

    handleSearchDebts = (filterParams, validation) => {
        if (validation.isValid) {
            this.getDebits(filterParams)

            this.setState({
                lastSearchParams: filterParams,
            })
        } else {
            this.setState({
                snackBarMessage: validation.errorMessage,
            }, () => {
                this.props.openSnackComp(true)
            })
        }
    }

    handleShowDebt = async () => {
        try {
            let bodyRequest = {
                Debitos: this.props.debitsSelectedIDsValue
            }

            const OcultarDebitoResponse = await api.put("Gestao/ReexibirDebitos", bodyRequest)

            if (OcultarDebitoResponse.data.EhValida) {

                this.setState({
                    loadingDAM: false,
                    errorDAM: false,
                }, () => {
                    this.getDebits(this.state.lastSearchParams)
                })

            } else {

                this.setState({
                    snackBarMessage: OcultarDebitoResponse.data.Erros[0] || 'Ocorreu um erro na operação.',
                    loadingDebits: false,
                })
                this.props.openSnackComp(true)
            }

        } catch (error) {
            this.setState({
                loadingDebits: false,
            })
        }
    }

    handleHideDebt = async () => {
        if (this.props.debitsSelectedIDsValue.length !== 1) {
            var errorMessage = "Selecione apenas um débito.";

            this.setState({
                snackBarMessage: errorMessage,
                loadingDebits: false,
            })
            this.props.openSnackComp(true)
        } else {
            try {
                let bodyRequest = {
                    Tipo: 0,
                    CpfCnpj: 0,
                    IdDebito: this.props.debitsSelectedIDsValue[0]
                }

                const OcultarDebitoResponse = await api.post("Gestao/OcultarDebito", bodyRequest)

                if (OcultarDebitoResponse.data.EhValida) {

                    this.setState({
                        loadingDAM: false,
                        errorDAM: false,
                    }, () => {
                        this.getDebits(this.state.lastSearchParams)
                    })

                } else {

                    this.setState({
                        snackBarMessage: OcultarDebitoResponse.data.Erros[0] || 'Ocorreu um erro na operação.',
                        loadingDebits: false,
                    })
                    this.props.openSnackComp(true)
                }

            } catch (error) {
                this.setState({
                    loadingDebits: false,
                })
            }
        }
    }

    handleGetCardSelected = (id, checked) => {
        if (checked) {
            this.setState({
                debitsSelected: [...this.state.debitsSelected, id],
                isHovering: !this.state.isHovering,
            }, () => {
                this.props.debitsSelectedIDsComp(this.state.debitsSelected)
            })
        } else {

            let updatedSelectedItems = this.state.debitsSelected
            updatedSelectedItems = arrayRemoveItem(updatedSelectedItems, id)

            this.setState({
                debitsSelected: updatedSelectedItems,
            }, () => {
                this.props.debitsSelectedIDsComp(updatedSelectedItems)
            })
        }
    }

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value })
        this.setState({ page: 0 });
    };

    render() {
        const { classes } = this.props;
        const { isNewPageInstance, loadingDebits, errorLoadDebits, errorMessage, snackBarMessage, rowsPerPage } = this.state;

        return (
            <div>
                <Snackbar
                    message={snackBarMessage}
                />

                <Grid container className={classes.container}>
                    <MenuDebitsManager />

                    {/* <Box width={1}>
                        <FilterDebitsManager LoadingDebits={loadingDebits} GetDebtsManager={this.handleSearchDebts} HasRequiredFields={false} />
                    </Box> */}

                    {this.props.debitsValue.length !== 0 && (<Box width={1} marginTop={2}>
                        <Box display="flex" justifyContent="flex-end">
                            <ButtonTypeName id='exibirBtn' typeButton={11} backgroundTransparent={true} onClick={this.handleShowDebt} />
                            {/*<ButtonTypeName id='ocultarBtn' typeButton={12} onClick={this.handleHideDebt} />*/}
                        </Box>
                    </Box>)}

                    {loadingDebits && (
                        <div className={classes.loadingDiv}>
                            <LoadingDefault typeLoading={'card'} />
                        </div>
                    )}

                    {!isNewPageInstance && this.props.debitsValue.length === 0 && !loadingDebits && !errorLoadDebits &&
                        <ContentNotLoaded message={Messages.NENHUM_DEBITO_OCULTO_ENCONTRADO_SISTEMA} />
                    }

                    {errorLoadDebits &&
                        <ContentNotLoaded message={errorMessage} />
                    }

                    {this.props.debitsValue.length > 0 &&
                        <div className={classes.cardContainer}>
                            <Grid container>
                                {(rowsPerPage > 0
                                    ? this.props.debitsValue.slice(this.state.page * rowsPerPage, this.state.page * rowsPerPage + rowsPerPage)
                                    : this.props.debitsValue
                                ).map(item => {
                                    return (
                                        <CardDebit
                                            key={item.IdDebito}
                                            classes={classes}
                                            handleGetCardSelected={this.handleGetCardSelected}
                                            contentCard={item}
                                            typeCard={"debits"}
                                            selectionModeActive={this.state.isInSelectionMode}
                                        />
                                    )
                                })}
                            </Grid>
                            <TablePagination
                                className={classes.pagination}
                                labelDisplayedRows={({ from, to, count }) => `${from} - ${to} de ${count}`}
                                labelRowsPerPage={sizePage <= 575 ? null : "Itens por página"}
                                rowsPerPageOptions={sizePage <= 575 ? [] : [4, 8, 12, 36]}
                                colSpan={3}
                                count={this.props.debitsValue.length}
                                rowsPerPage={rowsPerPage}
                                page={this.state.page}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                            />
                        </div>
                    }
                </Grid>
                <Footer />
            </div>
        )
    }
}

const mapStateToProps = (store) => ({
    debitsValue: store.cardDebitState.debitsValue,
    debitsSelectedValue: store.cardDebitState.debitsSelectedValue,
    debitsSelectedIDsValue: store.cardDebitState.debitsSelectedIDsValue,
    openSnackValue: store.cardDebitState.openSnackValue,
})

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        debitsComp,
        debitsSelectedComp,
        debitsSelectedIDsComp,
        openSnackComp
    }, dispatch);

export default withStyles(styles, { withTheme: true })(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(HiddenDebts)
);
